/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ScheduleQueryCreatedBy extends models.QueryOperator {
    constructor() {
        super();
        this.setDiscriminator("ScheduleQueryCreatedBy");
    }

    getFixupPrototypeFunction() { return ScheduleQueryCreatedBy.fixupPrototype; }

    static newInstance(model: Partial<ScheduleQueryCreatedBy>): ScheduleQueryCreatedBy {
        let obj = Object.assign(new ScheduleQueryCreatedBy(), model);
        ScheduleQueryCreatedBy.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ScheduleQueryCreatedBy>): ScheduleQueryCreatedBy {
        if (!model) return null;
        return ScheduleQueryCreatedBy.newInstance(<ScheduleQueryCreatedBy> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ScheduleQueryCreatedBy) {
        if (!obj) return;

        models.ScheduleQueryCreatedBy.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ScheduleQueryCreatedBy): boolean {
        if (models.QueryOperator.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ScheduleQueryCreatedBy.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Schedule Created by
     */
    created_by: Array<string>;

}
